import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'sawTime'
})
export class SawTimePipe implements PipeTransform {

  constructor(
    private _datePipe:DatePipe
  ) {}

  transform(value: any): any {
    let times = [];
    let total = 0;
    let start;
    if(!value || !value.length) return 0;
    value.forEach((i) => {
      times.push({
        timeType: i.timeType,
        date: Date.parse(i.date)
      })
    });
    times.forEach(function (t) {
      if(t.timeType == 'Start') {
        start = t.date;
      } else if(t.timeType == 'Stop') {
        if(start) {
          total = total + (t.date - start);
          start = null;
        }
      }
    });
    const minutes = Math.floor(total / 60000);
    //const seconds = Number(((total % 60000) / 1000).toFixed(0));
    //return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    return minutes;
  }


}



// WEBPACK FOOTER //
// ./src/app/reports/pipes/saw-time-pipe.ts